export const AUTHZ_FEATURES = {
  INCENTIVE: 'incentive',
  SLAB: 'slab',
  LIMIT_STORE: 'limit-store',
  BULK_PAY: 'bulkpay',
  SUBSCRIPTION: 'subscription',
  BILLING_PLANS: 'billingPlans',
};

export const LEGACY_INCENTIVE_PERMISSIONS = {
  view: 'view_incentive',
  edit: 'edit_incentive',
  approve: 'approve_incentive',
};

export const LEGACY_SLAB_PERMISSIONS = {
  view: null,
  create: 'create_slab',
  approve: 'approve_slab',
  createGeoSlab: 'create_geo_slab',
};

export const AUTHZ_INCENTIVE_PERMISSIONS = {
  view: 'pricing_config:captain_incentive:view',
  edit: 'pricing_config:captain_incentive:edit',
  approve: 'pricing_config:captain_incentive:approve',
};

export const AUTHZ_SLAB_PERMISSIONS = {
  view: 'pricing_config:slab:view',
  create: 'pricing_config:slab:edit',
  approve: 'pricing_config:slab:approve',
  createGeoSlab: 'pricing_config:geo_slab:edit',
};

export const LEGACY_LIMIT_STORE_PERMISSIONS = {
  view: 'view_limit_store',
  edit: 'create_limit_store',
  approve: 'approve_limit_store',
  approvalView: 'approval_view',
};

export const AUTHZ_LIMIT_STORE_PERMISSIONS = {
  view: 'pricing_config:limit_store:view',
  edit: 'pricing_config:limit_store:edit',
  approve: 'pricing_config:limit_store:approve',
};

export const LEGACY_BULK_PAY_PERMISSIONS = {
  view: 'bulkpay_history',
  create: 'bulkpay_create',
  edit: 'bulkpay_create',
  approve: 'bulkpay_approve',
};

export const AUTHZ_BULK_PAY_PERMISSIONS = {
  view: 'pricing_config:captain_bulk_pay:view',
  create: 'pricing_config:captain_bulk_pay:edit',
  edit: 'pricing_config:captain_bulk_pay:edit',
  approve: 'pricing_config:captain_bulk_pay:approve',
};

export const AUTHZ_SUBSCRIPTION_PERMISSIONS = {
  create: 'pricing_config:captain_subscription:edit',
  view: 'pricing_config:captain_subscription:view',
  edit: 'pricing_config:captain_subscription:edit',
  approve: 'pricing_config:captain_subscription:approve',
};

export const AUTHZ_BILLING_PLANS_PERMISSIONS = {
  view: 'pricing_config:captain_billing_plan:view',
  edit: 'pricing_config:captain_billing_plan:edit',
  approve: 'pricing_config:captain_billing_plan:approve',
};

/** No view tag: list stays open until the billingPlans panel is on. */
export const LEGACY_BILLING_PLAN_PERMISSIONS = {
  view: null,
  edit: 'captain_subscription_deactivate',
  approve: 'approve_subscription',
};

/** No view tag: list stays open until the subscription panel is on. Create is shared with Access Fee. */
export const LEGACY_SUBSCRIPTION_PERMISSIONS = {
  view: null,
  create: 'captain_subscription_create',
  edit: 'captain_subscription_deactivate',
  approve: 'approve_subscription',
};
